export const removeNullishValuesFromObject = <T extends object>(
  obj: T,
  ignore: string[] = []
): T => {
  Object.keys(obj).forEach(key => {
    if (ignore.includes(key)) return;

    const value = obj[key as keyof T];
    if (value === undefined || value === null) {
      delete obj[key as keyof T];
    }
  });

  return obj;
};
